import { MoveableBookFeature } from './moveable-book-feature';
import { environment } from '../../environments/environment';
import { Note } from './note';
import { Loggable } from './loggable';
import { Colorable } from './colorable';
import { Color } from './color';
import { TechnicalFeature } from '@lemberger/lemberger-am';

export class Rect extends MoveableBookFeature implements Note, Loggable, Colorable {

    noteText: string;
    updatedAt: any;
    zIndex = 7;
    logType = TechnicalFeature.Notes;
    tool: null;
    color: Color;
    open: boolean;

    getEndpointName(): string {
        return environment.endpointUrls.rects;
    }

    isPointNote(): boolean {
        return this.position.h === 0 && this.position.w === 0;
    }

}
